export default {"src":"/_next/static/media/flag-pt.5e75ded8.svg","height":400,"width":600,"blurWidth":0,"blurHeight":0};